import React from "react";
import styled from "styled-components";

const IconWrapper = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 36px;
  height: 36px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e5e5;
  padding: 6px;
  cursor: pointer;
  transition: transform 0.2s ease;
  z-index: 2;

  /* Mobile touch optimization */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    transform: scale(1.1);
  }
`;

const Heart = styled.span<{ isFavorite: boolean }>`
  font-size: 24px;
  line-height: 1;
  color: ${({ isFavorite }) => (isFavorite ? "#ff4d6a" : "#d0d0d0")};
`;

interface FavoriteIconProps {
  isFavorite: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onTouchStart?: (e: React.TouchEvent<HTMLDivElement>) => void;
  onTouchEnd?: (e: React.TouchEvent<HTMLDivElement>) => void;
}

const FavoriteIcon: React.FC<FavoriteIconProps> = ({ isFavorite, onClick, onTouchStart, onTouchEnd }) => (
  <IconWrapper onClick={onClick} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
    <Heart isFavorite={isFavorite} aria-label={isFavorite ? "즐겨찾기 활성" : "즐겨찾기 비활성"}>
      {isFavorite ? "♥" : "♡"}
    </Heart>
  </IconWrapper>
);

export default FavoriteIcon;
